import React from 'react';
import {YMaps, Map, FullscreenControl, Placemark} from 'react-yandex-maps';

const MyReactMapComponent = () => {
    return (
        <>
            <YMaps
                enterprise
                query={{
                    lang: 'ru_RU',
                    apikey: '4de870c8-5e28-4cee-a429-639e86c915d7'
                }}
            >
                <Map
                    style={{width: '100%', height: '100%'}}
                    defaultState={{
                        center: [43.893813, 42.718700],
                        zoom: 13
                    }}
                >
                    {/* Маркер на карте */}
                    <Placemark
                        modules={["geoObject.addon.balloon"]}
                        defaultGeometry={[43.893813, 42.718700]}
                        properties={{
                            balloonContentBody:
                                `
                                <div>
                                    <h5>Санаторий "Узбекистан"</h5>
                                    <h6>улица Парковый Пешеход, 21</h6>
                                </div>
                            `
                        }}
                    />
                    <FullscreenControl />
                </Map>
            </YMaps>
        </>
    );
};

export default MyReactMapComponent;